import { FormatTypes } from '@constants/templateDictionaries';
import {
  STANDARD_COVER_LETTER,
  STANDARD_RESUME,
} from '../ExpertTips/Shared/expertTipsEnums';

export const getKeyForExpertTips = (formatType) => {
  switch (formatType) {
    case FormatTypes.RESUME:
      return STANDARD_RESUME;
    case FormatTypes.COVER_LETTER:
      return STANDARD_COVER_LETTER;
    default:
      return null;
  }
};
